import { CustomUseInfiniteQueryOptions, PageParam } from '../types';
import { getNextPageParam, getPreviousPageParam } from '../utils';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { ApiInstance, SearchApiResult, SearchType } from '@/libs/sdk/api';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

export type SearchParams = Partial<PageParam> & {
  keyword: string;
  baseTokenAddress?: string;
};
export const useSearchUser = (
  api: ApiInstance,
  searchParams: SearchParams,
  options?: CustomUseInfiniteQueryOptions<SearchApiResult>
) => {
  const { page = 1, pageSize = 4 } = searchParams;
  const { queryKey, enabled = true, ...rest } = options || {};
  return useInfiniteQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(searchParams, ['keyword']),
    queryKey: [queryKey, 'SearchUser', searchParams],
    initialPageParam: { page, pageSize },
    queryFn: async ({ pageParam }) => {
      const { data } = await api.base.search({
        ...searchParams,
        marketPage: 0,
        marketPageSize: 0,
        userPage: pageParam.page,
        userPageSize: pageParam.pageSize,
        searchType: SearchType.user,
      });
      return { ...data, ...pageParam };
    },
    placeholderData: keepPreviousData,
    getPreviousPageParam,
    getNextPageParam: lastPage => getNextPageParam({ ...lastPage, total: lastPage.userTotal }),
  });
};
